import { useChartContext } from '@shopify/polaris-viz-core';
import { useCallback } from 'react';

function useLineChartTooltipContent({
  data,
  hiddenIndexes = [],
  indexForLabels,
  renderTooltipContent
}) {
  const {
    theme
  } = useChartContext();
  return useCallback(activeIndex => {
    if (activeIndex === -1) {
      return null;
    }

    const tooltipData = [{
      shape: 'Line',
      data: []
    }];
    const key = data[indexForLabels].data[activeIndex] ? data[indexForLabels].data[activeIndex].key : '';
    data.forEach(({
      name,
      data: seriesData,
      color,
      isComparison
    }, index) => {
      if (!seriesData[activeIndex]) {
        return;
      }

      const {
        value
      } = seriesData[activeIndex];
      tooltipData[0].data.push({
        key: `${name}`,
        value,
        color: color,
        isComparison,
        isHidden: hiddenIndexes.includes(index)
      });
    });
    return renderTooltipContent({
      data: tooltipData,
      activeIndex,
      title: `${key}`,
      dataSeries: data,
      theme
    });
  }, [data, renderTooltipContent, theme, hiddenIndexes, indexForLabels]);
}

export { useLineChartTooltipContent };
